// extracted by mini-css-extract-plugin
export default {"hide":"ScreenReaderHidden_hide__Md6sS"};